import React from 'react';
import { KAZAKHSTAN } from 'common/constants/region-codes';
import { RootLayout } from 'common/components';
import { useRegionIdSelector } from 'modules/model-json';
import { NewBathroom } from './new-bathroom';
import { BATHROOM_PATH } from './bathroom-constants';
import { OldBathroom } from './old-bathroom';

/**
 * Вью страницы "Ванные комнаты"
 */
export const Bathroom: React.FC = () => {
  const regionId = useRegionIdSelector();
  const designRegistrationHref = `/zapis-onlayn/?department_no=6&region_id=${regionId}`;

  if (regionId === KAZAKHSTAN) {
    return (
      <RootLayout currentPage={BATHROOM_PATH}>
        <OldBathroom />
      </RootLayout>
    );
  }

  return (
    <RootLayout currentPage={BATHROOM_PATH}>
      <NewBathroom designRegistrationHref={designRegistrationHref} regionId={regionId} />
    </RootLayout>
  );
}
